import { Pipe, PipeTransform } from '@angular/core';

import { isStatusActive } from '../../prisma-xs/helpers/bom-mapper.helper';
import { IBomModel } from '../../prisma-xs/models/bom.model';


@Pipe({
    name: 'isStatusActive',
    standalone: false
})
export class IsStatusActivePipe implements PipeTransform {

  transform(model: IBomModel): boolean {
    return isStatusActive(model?.article?.status);
  }

}
